export const STREETS_TYPES = {
    AVENUE: "AVENUE",
    SHRED: "SHRED",
    STREET: "STREET",
    MALL: "MALL",
    PIER: "PIER",
    PASSAGE: "PASSAGE",
    SQUARE: "SQUARE",
    NO_TYPE: "NO_TYPE",
};

export const STREETS_TYPES_LABELS = {
    [STREETS_TYPES.AVENUE]: "Avenida",
    [STREETS_TYPES.SHRED]: "Jirón",
    [STREETS_TYPES.STREET]: "Calle",
    [STREETS_TYPES.MALL]: "Alameda",
    [STREETS_TYPES.PIER]: "Malecón",
    [STREETS_TYPES.PASSAGE]: "Pasaje",
    [STREETS_TYPES.SQUARE]: "Plaza",
    [STREETS_TYPES.NO_TYPE]: "Sin tipo",
};

export const ABBREVIATION_STREETS_TYPES_LABELS = {
    [STREETS_TYPES.AVENUE]: "Av.",
    [STREETS_TYPES.SHRED]: "Jr.",
    [STREETS_TYPES.STREET]: "Ca.",
    [STREETS_TYPES.MALL]: "Al.",
    [STREETS_TYPES.PIER]: "Ml.",
    [STREETS_TYPES.PASSAGE]: "Pje.",
    [STREETS_TYPES.SQUARE]: "Pl.",
    [STREETS_TYPES.NO_TYPE]: "Sin tipo",
};

export const URBANIZATION_TYPES = {
    URBANIZATION: "URBANIZATION",
    URBAN_HABILITATION: "URBAN_HABILITATION",
    HOUSING_COMPLEX: "HOUSING_COMPLEX",
    HUMAN_SETTLEMENT: "HUMAN_SETTLEMENT",
    NEIGHBORHOOD_UNIT: "NEIGHBORHOOD_UNIT",
    ASSOCIATION: "ASSOCIATION",
    GROUP: "GROUP",
    NO_TYPE: "NO_TYPE",
};

export const URBANIZATION_TYPES_LABELS_NST = {
    [URBANIZATION_TYPES.URBANIZATION]: "Urbanización",
    [URBANIZATION_TYPES.URBAN_HABILITATION]: "Habilitación urbana",
    [URBANIZATION_TYPES.HOUSING_COMPLEX]: "Conjunto habitacional",
    [URBANIZATION_TYPES.HUMAN_SETTLEMENT]: "Asentamiento humano",
    [URBANIZATION_TYPES.NEIGHBORHOOD_UNIT]: "Unidad vecinal",
    [URBANIZATION_TYPES.ASSOCIATION]: "Asociación",
    [URBANIZATION_TYPES.GROUP]: "Agrupación",
};
export const URBANIZATION_TYPES_LABELS = {
    ...URBANIZATION_TYPES_LABELS_NST,
    [URBANIZATION_TYPES.NO_TYPE]: "Sin tipo",
};
